import {
    i18nMessages,
    toExtendedAddressInputKey,
    AddressFormat,
    AddressFieldWithCountry,
    ExtendedAddressInputKey,
} from '@precon-tools-suite-by-shared/js-commerceguys-addressing';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useI18n, UseI18nOptions } from 'vue-i18n';

export function useAddressFormat(
    input: MaybeRefOrGetter<AddressFormat | null | undefined>
) {
    const addressFormat = computed(
        () => toValue(input) ?? AddressFormat.default()
    );

    return addressFormat;
}

export function useAddressFormatFields(
    input: MaybeRefOrGetter<AddressFormat | null | undefined>,
    options: UseI18nOptions = {}
) {
    const { t } = useI18n({
        messages: i18nMessages,
        ...options,
    });

    const addressFormat = useAddressFormat(input);

    function getFieldLabel(
        field: AddressFieldWithCountry | ExtendedAddressInputKey
    ) {
        const inputKey = toExtendedAddressInputKey(field);
        switch (inputKey) {
            case 'locality':
                return t(`localityType.${addressFormat.value.localityType}`);
            case 'dependentLocality':
                return t(
                    `dependentLocalityType.${addressFormat.value.dependentLocalityType}`
                );
            case 'postalCode':
                return t(
                    `postalCodeType.${addressFormat.value.postalCodeType}`
                );
            default:
                return t(`addressInputKeys.${inputKey}`);
        }
    }

    return { addressFormat, getFieldLabel };
}
